// extracted by mini-css-extract-plugin
export var dividerContainer = "_66-0";
export var line = "_66-1";